module.exports = __webpack_public_path__ + "static/media/ico_close.49670621.svg";